import endpoints from '../endpoints';
import fetchReq from '../fetch';

type FetchDeviceIdOptions = {
  sessionId: string;
};

export default async function fetchDeviceId({
  sessionId
}: FetchDeviceIdOptions): Promise<string | null> {
  const res = await fetchReq({
    body: {
      context: {
        channel: 'Web',
        eventSource: 'LightboxTW',
        uebas: [
          {
            // VCO-14303 - as of Holiday 2020, THM profile ID is being returned
            // all lowercase; re-use X-THMID/sessionId value with original
            // casing.
            ueba_id: sessionId,
            ueba_source: 'THM'
          }
        ]
      }
    },
    mark: 'thm_device',
    method: 'POST',
    url: endpoints.device
  });

  if (!res.ok) {
    return null;
  }

  // VCO-14593 - /idLookup requires x-via-hint instead of x-via-hint_dca
  // get 'x-via-hint_dca' header and preserve for subsequent fetch calls (UNL is primary use-case)
  return res.headers['x-via-hint'] ?? null;
}
